import React from 'react'
import { ShieldCheck, AlertCircle, ShieldAlert } from 'lucide-react'
import { cn } from '../../../utils/classnames'

const TwoFactorStatusBadge = ({ enabled }) => {
  const isEnabled = enabled

  return (
    <div
      className={cn(
        'inline-flex items-center gap-1 px-4 py-1 rounded-full text-xs font-semibold',
        isEnabled
          ? 'bg-tealMedium text-white'
          : 'bg-redSoft text-white'
      )}
    >
      {isEnabled ? (
        <ShieldCheck size={14} strokeWidth={2} />
      ) : (
        <ShieldAlert size={14} strokeWidth={2} />
      )}
      {isEnabled ? 'HABILITADA' : 'DESABILITADA'}
    </div>
  )
}

export default TwoFactorStatusBadge
